import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, HasProductContext, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLanguages } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import Hidden from "@insite/mobius/Hidden/Hidden";
import Select from "@insite/mobius/Select";
import Typography from "@insite/mobius/Typography";
import { injectCss } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { Data } from "@react-google-maps/api";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import React, { FC, useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css, withTheme } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    session: getSession(state),
});
const mapDispatchToProps = {};

type Props = HasProduct & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface SizingStyle {
    container: InjectableCss;
    button: InjectableCss;
    title: InjectableCss;
}

export const sizingStyle: SizingStyle = {
    container: {
        css: css`
            margin-top: 20px;
            width: 100%;
        `,
    },

    button: {
        css: css`
            align-items: center;
            padding: 8px 15px !important;
            background: ${getColor("secondary")};
            
            border: 1px solid ${getColor("primary")};
            margin-right: 12px;
            margin-top: 10px;
            /* text-transform: uppercase; */
            &:hover {
                background: ${getColor("secondary")};
            }
            border-radius: 0px;
            span {
                font-family: ${TYPOGRAPHY.fontFamily.base};
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.base};
                font-size: ${TYPOGRAPHY.size.smaller};
                line-height: ${TYPOGRAPHY.lineHeight.base};
                text-align: center;
                color: ${COLORS.text.main};
            }
        `,
    },
    title: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.bold};
            font-size: ${TYPOGRAPHY.size.base};
            line-height: ${TYPOGRAPHY.lineHeight.xbase};
            color: ${getColor("text.main")};
        `,
    },
};

const styles = sizingStyle;

const ProductSizing: React.FC<any> = ({ product }) => {
    return (
        <>
            <StyledWrapper {...styles.container}>
                <Typography {...styles.title}>Size</Typography>
                {/* <Hidden below="lg"> */}
                <StyledWrapper>
                    {product.variantTraits?.map((item: any) => {
                        return item.traitValues.map((data: any, index: any) => {
                            return (
                                <Button key={data.id} {...styles.button}>
                                    {data.value}
                                </Button>
                            );
                        });
                    })}
                </StyledWrapper>
                {/* </Hidden> */}
                {/* <Hidden above="md">
                    <StyledWrapper>
                        <Select>
                            {product.variantTraits[0].traitValues.map((data: any) => (
                                <option key={data.value} value={data.value}>
                                    {data.value}
                                </option>
                            ))}
                        </Select>
                    </StyledWrapper>
                </Hidden> */}
            </StyledWrapper>
        </>
    );
};

const SizingWidget: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withProduct(ProductSizing)),
    definition: {
        group: "Basic",
        displayName: "Sizing Widget",
        fieldDefinitions: [],
    },
};

export default SizingWidget;
